import React, { Component } from "react";
import ReactDOM from 'react-dom';
import axios from "axios";
import SimplePagination from "./SimplePagination";
import { getErrorsMessage, getSuccessMessage } from '../utils.js';
import { LangContext } from "../LangContext.jsx";
class UserProfileForm extends Component {
    static contextType = LangContext;
    constructor(props) {
        super();
        this.state = {
            profile:[],
            dossiers:[],
            documents:[],
            providers:[],
            reminders:[],
            api:[],
            cost_centers:[],
            cost_centers_list:[],
            providers_list:[],
            dossiers_actions:[],
            dossiers_list:[],
            documents_list:[],
            documents_actions:[],
            reports_list:[],
            providers_list_internal:[],
            providers_list_own:[],
            user_actions:[],
            my_account: [],
            guest: [],
            plans: [],
            has_venvers: false,
        };
    }
    async componentDidMount() {
        await  this.getData()
        await axios.get('/api/profiles/'+this.props.id).then(res=>{
            console.log(res.data)
            let documents_actions = res.data.documents_actions

            $('#documents_actions').val(JSON.parse(documents_actions));
            $('#documents_actions').trigger('change');

            $('#name').val(res.data.name);
            $('#description').val(res.data.description);

            $('#users_list').val(JSON.parse(res.data.users));
            $('#users_list').trigger('change');

            $('#user_notifications').val(JSON.parse(res.data.user_notifications));
            $('#user_notifications').trigger('change');

            $('#dossiers').val(JSON.parse(res.data.dossiers));
            $('#dossiers').trigger('change');

            $('#documents_list').val(JSON.parse(res.data.documents_list));
            $('#documents_list').trigger('change');

            $('#documents').val(JSON.parse(res.data.documents));
            $('#documents').trigger('change');

            $('#api').val(JSON.parse(res.data.api));
            $('#api').trigger('change');

            $('#cost_center').val(JSON.parse(res.data.cost_centers));
            $('#cost_center').trigger('change');

            $('#providers').val(JSON.parse(res.data.providers));
            $('#providers').trigger('change');

            $('#cost_centers_list').val(JSON.parse(res.data.cost_centers_list));
            $('#cost_centers_list').trigger('change');

            $('#providers_list').val(JSON.parse(res.data.providers_list));
            $('#providers_list').trigger('change');

            $('#dossiers_actions').val(JSON.parse(res.data.dossiers_actions));
            $('#dossiers_actions').trigger('change');

            $('#dossiers_actions_internal').val(JSON.parse(res.data.dossiers_actions_internal));
            $('#dossiers_actions_internal').trigger('change');

            $('#dossiers_actions_own').val(JSON.parse(res.data.dossiers_actions_own || '[]'));
            $('#dossiers_actions_own').trigger('change');

            $('#providers_list_own').val(JSON.parse(res.data.providers_list_own || '[]'));
            $('#providers_list_own').trigger('change');

            $('#documents_actions_own').val(JSON.parse(res.data.documents_actions_own || '[]'));
            $('#documents_actions_own').trigger('change');

            $('#reports_list_own').val(JSON.parse(res.data.reports_list_own || '[]'));
            $('#reports_list_own').trigger('change');

            $('#reports_list').val(JSON.parse(res.data.reports_list));
            $('#reports_list').trigger('change');

            $('#reminders').val(JSON.parse(res.data.reminders));
            $('#reminders').trigger('change');

            $('#dossiers_list').val(JSON.parse(res.data.dossiers_list));
            $('#dossiers_list').trigger('change');

            $('#profiles').val(JSON.parse(res.data.profiles));
            $('#profiles').trigger('change');

            $('#providers_list_internal').val(JSON.parse(res.data.providers_list_internal));
            $('#providers_list_internal').trigger('change');

            $('#reports_list_internal').val(JSON.parse(res.data.reports_list_internal));
            $('#reports_list_internal').trigger('change');

            $('#documents_actions_internal').val(JSON.parse(res.data.documents_actions_internal));
            $('#documents_actions_internal').trigger('change');

            $('#reports_list_internal').val(JSON.parse(res.data.reports_list_internal));
            $('#reports_list_internal').trigger('change');

            $('#user_actions').val(JSON.parse(res.data.user_actions));
            $('#user_actions').trigger('change');

            $('#my_account').val(JSON.parse(res.data.my_account || '[]'));
            $('#my_account').trigger('change');

            $('#guest').val(JSON.parse(res.data.guest || '[]'));
            $('#guest').trigger('change');

            $('#plans').val(JSON.parse(res.data.plans || '[]'));
            $('#plans').trigger('change'); 
            $('#venvers').val(JSON.parse(res.data.venvers || '[]'));
            $('#venvers').trigger('change');
        })

        const fv = FormValidation.formValidation(KTUtil.getById('frm'), {
            fields: {
                name: {
                    validators: {
                        notEmpty: {
                            message: 'Nombre requerido'
                        },
                        stringLength: {
                            min: 4,
                            max: 200,
                            message: 'El nombre debe tener una longitud mínima de 4'
                        },
                    }
                },
            },
            plugins: {
                trigger: new FormValidation.plugins.Trigger(),
                bootstrap: new FormValidation.plugins.Bootstrap({
                    eleInvalidClass: '',
                    eleValidClass: '',
                })
            },
        });

        const btnPublish = document.getElementById('btnPublish');
        btnPublish.addEventListener('click', () => {
            fv.validate().then((status) => {
                if (status == 'Valid') {
                    window.blockUI();
                    var form = document.getElementById("frm");
                    var formData = new FormData(form);
                    axios.post('/api/profiles/'+this.props.id,formData).then(res=>{
                        window.unblockUI();
                        swal.fire({
                            text: "Guardado",
                            icon: "success",
                            buttonsStyling: false,
                            confirmButtonText: "Aceptar",
                            customClass: {
                                confirmButton: "btn font-weight-bold btn-primary"
                            },
                            timer: 3000
                        }).then(function(result) {
                            window.location.href = '/profiles';
                        });
                    })
                }
            })
        });
    }

    async getData(){
        var url = '/profiles/data';
        const res = await axios.get(url);
        this.setState({dossiers:  res.data.dossiers});
        this.setState({documents:  res.data.documents});
        this.setState({api:  res.data.api});
        this.setState({cost_centers:  res.data.cost_centers});
        this.setState({cost_centers_list:  res.data.cost_centers_list});
        this.setState({providers_list:  res.data.providers_list});
        this.setState({providers_list_internal:  res.data.providers_list_internal});
        this.setState({providers_list_own:  res.data.providers_list_own});

        this.setState({providers:  res.data.providers});
        this.setState({dossiers_actions:  res.data.dossiers_actions});
        this.setState({dossiers_list:  res.data.dossiers_list});
        this.setState({reminders:  res.data.reminders});
        this.setState({documents_list:  res.data.documents_list});
        this.setState({documents_actions:  res.data.documents_actions});
        this.setState({reports_list:  res.data.reports_list});

        this.setState({reports_list_internal:  res.data.reports_list_internal});
        this.setState({documents_actions_internal:  res.data.documents_actions_internal});
        this.setState({reports_list_internal:  res.data.reports_list_internal});
        this.setState({user_actions:  res.data.user_actions});
        this.setState({has_venvers: res.data.has_venvers});

    }
    render() {
        const { lang } = this.context; 
        return (
        <>
            <form id="frm">
                <div class="subheader py-6 py-lg-8 subheader-transparent" id="kt_subheader">
                    <div class="container d-flex align-items-center justify-content-between flex-wrap flex-sm-nowrap">
                        <div class="d-flex align-items-center flex-wrap mr-1">
                            <div class="d-flex align-items-baseline flex-wrap mr-5">
                                <h5 class="text-dark font-weight-bold my-1 mr-5">
                                    {lang.get('messages.editar_perfil')}
                                </h5>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="d-flex flex-column-fluid">
                    <div class="container">
                        <div class="card card-custom gutter-b">
                            <div class="card-body">
                                <h5>{lang.get('messages.datos_del_perfil')}</h5>
                                <br />
                                <div class="row justify-content-center text-left">
                                    <div class="col-sm-6 form-group">
                                        <label class="text-left">{lang.get('messages.nombre')}</label>
                                        <input type="text" id="name" name="name" class="form-control form-control-solid"   autoFocus placeholder={lang.get('messages.nombre_del_perfil')} />
                                    </div>
                                    <div class="col-sm-6 form-group">
                                        <label class="text-left">{lang.get('messages.descripcion')}</label>
                                        <input type="text" id="description" name="description" class="form-control form-control-solid"   autoFocus placeholder={lang.get('messages.descripcion_del_perfil')} />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <br />
                        <div class="card card-custom gutter-b">
                            <div class="card-body">
                                <ul class="nav nav-tabs nav-tabs-line">
                                    <li class="nav-item">
                                        <a class="nav-link active" data-toggle="tab" href="#kt_tab_pane_1">{lang.get('messages.permisos_de_configuracion')}</a>
                                    </li>
                                    <li class="nav-item">
                                        <a class="nav-link" data-toggle="tab" href="#kt_tab_pane_2">{lang.get('messages.permisos_de_operacion')}</a>
                                    </li>
                                    {/*
                                    <li class="nav-item">
                                        <a class="nav-link" data-toggle="tab" href="#kt_tab_pane_3">Notificaciones</a>
                                    </li>
                                    */}
                                </ul>
                                <div class="tab-content mt-5" id="myTabContent">
                                    <div class="tab-pane fade show active" id="kt_tab_pane_1" role="tabpanel" aria-labelledby="kt_tab_pane_2">
                                        <div class="row form-group">
                                            <div class="col-sm-3 text-right col-form-label">
                                                {lang.get('messages.usuarios')}
                                            </div>
                                            <div class="col-sm-9">
                                                <select id="users_list" class="form-control select2" name="users[]" multiple="multiple">
                                                    <option value="all"  selected="selected">{lang.get('messages.todos')}</option>
                                                    <option value="create">{lang.get('messages.crear')}</option>
                                                    <option value="edit">{lang.get('messages.editar')}</option>
                                                    <option value="list">{lang.get('messages.ver_listado')}</option>
                                                    <option value="delete">{lang.get('messages.borrar')}</option>
                                                    <option value="none">{lang.get('messages.ninguna_accion')}</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="row form-group">
                                            <div class="col-sm-3 text-right col-form-label">
                                            {lang.get('messages.plantillas_de_expedientes')}
                                            </div>
                                            <div class="col-sm-9">
                                                <select id="dossiers" class="form-control select2" name="dossiers[]" multiple="multiple">
                                                    <option value="all"  selected="selected">{lang.get('messages.todos')}</option>
                                                    <option value="create">{lang.get('messages.crear')}</option>
                                                    <option value="edit">{lang.get('messages.editar')}</option>
                                                    <option value="list">{lang.get('messages.ver_listado')}</option>
                                                    <option value="delete">{lang.get('messages.borrar')}</option>
                                                    <option value="none">{lang.get('messages.ninguna_accion')}</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="row form-group">
                                            <div class="col-sm-3 text-right col-form-label">
                                            {lang.get('messages.plantillas_de_documentos')}
                                            </div>
                                            <div class="col-sm-9">
                                                <select id="documents" class="form-control select2" name="documents[]" multiple="multiple">
                                                    <option value="all"  selected="selected">{lang.get('messages.todos')}</option>
                                                    <option value="create">{lang.get('messages.crear')}</option>
                                                    <option value="frequency">{lang.get('messages.modificar_frecuencia')}</option>
                                                    <option value="format">{lang.get('messages.modificar_formato')}</option>
                                                    <option value="list">{lang.get('messages.ver_listado')}</option>
                                                    <option value="delete">{lang.get('messages.borrar')}</option>
                                                    <option value="duplicate">{lang.get('messages.duplicate')}</option>
                                                    <option value="none">{lang.get('messages.ninguna_accion')}</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="row form-group">
                                            <div class="col-sm-3 text-right col-form-label">
                                                API
                                            </div>
                                            <div class="col-sm-9">
                                                <select id="api" class="form-control select2" name="api[]" multiple="multiple">
                                                    <option value="all"  selected="selected">{lang.get('messages.todos')}</option>
                                                    <option value="create">{lang.get('messages.crear')}</option>
                                                    <option value="edit">{lang.get('messages.editar')}</option>
                                                    <option value="list">{lang.get('messages.ver_listado')}</option>
                                                    <option value="delete">{lang.get('messages.borrar')}</option>
                                                    <option value="none">{lang.get('messages.ninguna_accion')}</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="row form-group">
                                            <div class="col-sm-3 text-right col-form-label">
                                            {lang.get('messages.centros_de_costos')}
                                            </div>
                                            <div class="col-sm-9">
                                                <select id="cost_center"  class="form-control select2" name="cost_centers[]" multiple="multiple">
                                                    <option value="all"  selected="selected">{lang.get('messages.todos')}</option>
                                                    <option value="create">{lang.get('messages.crear')}</option>
                                                    <option value="edit">{lang.get('messages.editar')}</option>
                                                    <option value="list">{lang.get('messages.ver_listado')}</option>
                                                    <option value="delete">{lang.get('messages.borrar')}</option>
                                                    <option value="none">{lang.get('messages.ninguna_accion')}</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="row form-group">
                                            <div class="col-sm-3 text-right col-form-label">
                                            {lang.get('messages.perfiles')}
                                            </div>
                                            <div class="col-sm-9">
                                                <select id="profiles"  class="form-control select2" name="profiles[]" multiple="multiple">
                                                    <option value="all"  selected="selected">{lang.get('messages.todos')}</option>
                                                    <option value="create">{lang.get('messages.crear')}</option>
                                                    <option value="edit">{lang.get('messages.editar')}</option>
                                                    <option value="list">{lang.get('messages.ver_listado')}</option>
                                                    <option value="delete">{lang.get('messages.borrar')}</option>
                                                    <option value="none">{lang.get('messages.ninguna_accion')}</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="row form-group">
                                            <div class="col-sm-3 text-right col-form-label">
                                            {lang.get('messages.invitados')}
                                            </div>
                                            <div class="col-sm-9">
                                                <select id="providers" class="form-control select2" name="providers[]" multiple="multiple">
                                                    <option value="all"  selected="selected">{lang.get('messages.todos')}</option>
                                                    <option value="invite">{lang.get('messages.invitar')}</option>
                                                    <option value="list">{lang.get('messages.ver_listado')}</option>
                                                    <option value="edit">{lang.get('messages.activar__desactivar')}</option>
                                                    <option value="delete_invitations">{lang.get('messages.eliminar_invitaciones')}</option>
                                                    <option value="resend_invitation">Reenviar invitación</option>
                                                    <option value="none">{lang.get('messages.ninguna_accion')}</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="row form-group">
                                            <div class="col-sm-3 text-right col-form-label">
                                            {lang.get('messages.recordatorios')}
                                            </div>
                                            <div class="col-sm-9">
                                                <select id="reminders" class="form-control select2" name="reminders[]" multiple="multiple">
                                                    <option value="all"  selected="selected">{lang.get('messages.todos')}</option>
                                                    <option value="list">{lang.get('messages.ver')}</option>
                                                    <option value="create">{lang.get('messages.crear')}</option>
                                                    <option value="edit">{lang.get('messages.editar')}</option>
                                                    <option value="none">{lang.get('messages.ninguna_accion')}</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="tab-pane fade" id="kt_tab_pane_2" role="tabpanel" aria-labelledby="kt_tab_pane_2">
                                        <div class="row form-group">
                                            <div class="col-sm-3 text-right col-form-label">
                                            {lang.get('messages.listado_de_plantillas_de_documentos')}
                                            </div>
                                            <div class="col-sm-9">
                                                <select class="form-control select2" id="documents_list" name="documents_list[]" multiple="multiple">
                                                <option value="all"  selected="selected">Todos</option>
                                                    {this.state.documents_list.map(function(p,i){
                                                        return <option value={p.id}  >{p.title}</option>
                                                    })}
                                                <option value="none">{lang.get('messages.ninguno')}</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="row form-group">
                                            <div class="col-sm-3 text-right col-form-label">
                                            {lang.get('messages.listado_de_plantillas_de_expedientes')}
                                            </div>
                                            <div class="col-sm-9">
                                                <select id="dossiers_list" class="form-control select2" name="dossiers_list[]" multiple="multiple">
                                                    <option value="all"  selected="selected">{lang.get('messages.todos')}</option>
                                                    {this.state.dossiers_list.map(function(p,i){
                                                        return <option value={p.id}  >{p.title}</option>
                                                    })}
                                                    <option value="none">{lang.get('messages.ninguno')}</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="row form-group">
                                            <div class="col-sm-3 text-right col-form-label">
                                            {lang.get('messages.invitados')}
                                            </div>
                                        </div>
                                        <div class="row form-group">
                                            <div class="col-sm-3 text-right col-form-label">
                                            {lang.get('messages.listado_de_invitados')}
                                            </div>
                                            <div class="col-sm-9">
                                                <select id="providers_list" class="form-control select2" name="providers_list[]" multiple="multiple">
                                                    <option value="all"  selected="selected">{lang.get('messages.todos')}</option>
                                                    {this.state.providers_list.map(function(p,i){
                                                            return <option value={p.persona_provider_id}  >{p.fiscal_name}</option>
                                                    }) }
                                                    <option value="none">{lang.get('messages.ninguno')}</option>
                                                </select>
                                            </div>
                                        </div>



                                        <div class="row form-group">
                                            <div class="col-sm-3 text-right col-form-label">
                                            {lang.get('messages.acciones_sobre_expedientes')}
                                            </div>
                                            <div class="col-sm-9">
                                                <select id="dossiers_actions" class="form-control select2" name="dossiers_actions[]" multiple="false">
                                                    <option value="all" >{lang.get('messages.todos')}</option>
                                                    <option value="download">{lang.get('messages.descargar_expediente_completo')}</option>
                                                    <option value="share">{lang.get('messages.compartir_documentos')}</option>
                                                    <option value="request">{lang.get('messages.solicitar_nuevo_documento')}</option>
                                                    <option value="export_reports">{lang.get('messages.exportar_reportes')}</option>
                                                    <option value="delete">Borrar expedientes</option>
                                                    <option value="delete_document_requests">Borrar solicitud de documentos</option>
                                                    <option value="delete_document_request">Borrar solicitud de documento</option>
                                                    <option value="delete_documents">Borrar documento (individual)</option>
                                                    <option value="delete_document">Borrar documentos (masivo)</option>
                                                    <option value="stop_recurrence">Suspender recurrencia</option>
                                                    <option value="start_recurrence">Reactivar recurrencia</option>
                                                    <option value="replace_dossier">Reemplazar expediente</option>
                                                    <option value="generate_historic">Generar Documentos historicos</option>
                                                    <option value="replace_template">Reemplazar plantilla de documento</option>
                                                    <option value="none">{lang.get('messages.ninguno')}</option>
                                                </select>
                                            </div>
                                        </div>

                                        <div class="row form-group">
                                            <div class="col-sm-3 text-right col-form-label">
                                                Mi cuenta
                                            </div>
                                            <div class="col-sm-9">
                                                <select class="form-control select2" id="my_account" name="my_account[]" multiple="multiple">
                                                    <option value="all">{lang.get('messages.todos')}</option>
                                                    <option value="add_company">Agregar Empresa</option>
                                                    <option value="update_email">Actualizar Correo</option>
                                                    <option value="make_owner">Convertir a propietario</option>
                                                    <option value="import_templates">Replicar configuración de plantillas</option>
                                                    <option value="conectivities">Conectividades</option>
                                                    <option value="none">{lang.get('messages.ninguno')}</option>
                                                </select>
                                            </div>
                                        </div>

                                        <div class="row form-group">
                                            <div class="col-sm-3 text-right col-form-label">
                                                Invitado
                                            </div>
                                            <div class="col-sm-9">
                                                <select class="form-control select2" id="guest" name="guest[]" multiple="multiple">
                                                    <option value="all">{lang.get('messages.todos')}</option>
                                                    <option value="update_guest_data">Actualizar datos del invitado</option>
                                                    <option value="update_guest_email">Actualizar correo del invitado</option>
                                                    <option value="none">{lang.get('messages.ninguno')}</option>
                                                </select>
                                            </div>
                                        </div>

                                        <div class="row form-group">
                                            <div class="col-sm-3 text-right col-form-label">
                                                Planes
                                            </div>
                                            <div class="col-sm-9">
                                                <select class="form-control select2" id="plans" name="plans[]" multiple="multiple">
                                                    <option value="all">{lang.get('messages.todos')}</option>
                                                    <option value="upgrade_plan">Incrementar plan</option>
                                                    <option value="none">{lang.get('messages.ninguno')}</option>
                                                </select>
                                            </div>
                                        </div>
 
                                            <div class="row form-group"  style={!this.state.has_venvers ? { display: 'none' } : {}}>
                                                <div class="col-sm-3 text-right col-form-label">
                                                    Venvers
                                                </div>
                                                <div class="col-sm-9">
                                                    <select class="form-control select2" id="venvers" name="venvers[]" multiple="multiple">
                                                        <option value="all">{lang.get('messages.todos')}</option>
                                                        <option value="connect">Conectar</option>
                                                        <option value="list_providers">Ver Listado de Proveedores</option>
                                                        <option value="none">{lang.get('messages.ninguno')}</option>
                                                    </select>
                                                </div>
                                            </div>
                                                {!this.state.has_venvers && (
                                            <input type="hidden" name="venvers[]" value="all" />
                                                )}

                                        <div class="row form-group">
                                            <div class="col-sm-3 text-right col-form-label">
                                            {lang.get('messages.acciones_sobre_documentos')}
                                            </div>
                                            <div class="col-sm-9">
                                                <select class="form-control select2" id="documents_actions" name="documents_actions[]" multiple="multiple">
                                                    <option value="all"  selected="selected">{lang.get('messages.todos')}</option>
                                                    <option value="load">{lang.get('messages.cargar')}</option>
                                                    <option value="comment">{lang.get('messages.comentar')}</option>
                                                    <option value="download">{lang.get('messages.descargar_documento_compartido')}</option>
                                                    <option value="massive_download">{lang.get('messages.descarga_masiva')}</option>
                                                    <option value="individual_download">{lang.get('messages.descarga_individual__previsualizar')}</option>
                                                    <option value="edit">{lang.get('messages.aprobar__rechazar')}</option>
                                                    <option value="view_document">Ver documento</option>
                                                    <option value="delete_document">Borrar documento</option>
                                                    <option value="status_log">Bitácora de Estatus</option>
                                                    <option value="delete_document_request">Borrar Solicitud de Documento</option>
                                                    <option value="export_compact_report">Exportar Reporte Compacto</option>
                                                    <option value="export_extra_fields_report_columns">Exportar Reporte Campos Extra con Columnas</option>
                                                    <option value="none">{lang.get('messages.ninguno')}</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="row form-group">
                                            <div class="col-sm-3 text-right col-form-label">
                                            {lang.get('messages.listado_de_reportes')}
                                            </div>
                                            <div class="col-sm-9">
                                                <select class="form-control select2" id="reports_list" name="reports_list[]" multiple="multiple">
                                                    <option value="all"  selected="selected">{lang.get('messages.todos')}</option>
                                                    <option value="dossiers"  className="disable_report_list">{lang.get('messages.reporte_de_expedientes')}</option>
                                                    <option value="documents" className="disable_report_list">{lang.get('messages.reporte_de_documentos')}</option>
                                                    <option value="providers" className="disable_report_list">{lang.get('messages.reporte_de_invitados')}</option>
                                                    <option value="invitations" className="disable_report_list">{lang.get('messages.reporte_de_invitaciones')}</option>
                                                    <option value="dossier_templates"  className="disable_report_list">{lang.get('messages.reporte_de_plantilla_de_expedientes')}</option>
                                                    <option value="document_templates" className="disable_report_list">{lang.get('messages.reporte_de_plantilla_de_documentos')}</option>
                                                    <option value="users" className="disable_report_list">{lang.get('messages.reporte_de_usuarios')}</option>
                                                    <option value="none">{lang.get('messages.ninguno')}</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="row form-group">
                                            <div class="col-sm-3 text-right col-form-label">
                                            {lang.get('messages.acciones_sobre_usuarios')}
                                            </div>
                                            <div class="col-sm-9">
                                                <select class="form-control select2" id="user_actions" name="user_actions[]" multiple="multiple">
                                                    <option value="all"  selected="selected">{lang.get('messages.todos')}</option>
                                                    <option value="transfer_account"  className="disable_report_list">{lang.get('messages.ceder_derechos_de_cuenta')}</option>
                                                    <option value="none">{lang.get('messages.ninguno')}</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="row form-group">
                                            <div class="col-sm-3 text-right col-form-label">
                                            {lang.get('messages.expedientes_internos')}
                                            </div>
                                        </div>
                                        <div class="row form-group">
                                            <div class="col-sm-3 text-right col-form-label">
                                            {lang.get('messages.listado_de_invitados')}
                                            </div>
                                            <div class="col-sm-9">
                                                <select id="providers_list_internal" class="form-control select2" name="providers_list_internal[]" multiple="multiple">
                                                    <option value="all"  selected="selected">{lang.get('messages.todos')}</option>
                                                    {this.state.providers_list_internal.map(function(p,i){
                                                            return <option value={p.persona_provider_id}  >{p.fiscal_name}</option>
                                                    }) }
                                                    <option value="none">{lang.get('messages.ninguno')}</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="row form-group">
                                            <div class="col-sm-3 text-right col-form-label">
                                            {lang.get('messages.acciones_sobre_expedientes')}
                                            </div>
                                            <div class="col-sm-9">
                                                <select id="dossiers_actions_internal" class="form-control select2" name="dossiers_actions_internal[]" multiple="false">
                                                    <option value="all">{lang.get('messages.todos')}</option>
                                                    <option value="transfer">{lang.get('messages.transferir')}</option>
                                                    <option value="download">{lang.get('messages.descargar_expediente_completo')}</option>
                                                    <option value="share">{lang.get('messages.compartir_documentos')}</option>
                                                    <option value="massive_upload">{lang.get('messages.carga_masiva')}</option>
                                                    <option value="request">{lang.get('messages.solicitar_nuevo_documento')}</option>
                                                    <option value="stop_recurrence">Suspender recurrencia</option>
                                                    <option value="start_recurrence">Reactivar recurrencia</option>
                                                    <option value="replace_dossier">Reemplazar expediente</option>
                                                    <option value="generate_historic">Generar Documentos historicos</option>
                                                    <option value="replace_template">Reemplazar plantilla de documento</option>
                                                    <option value="delete">Borrar expediente</option>
                                                    <option value="delete_documents">Borrar documentos</option>
                                                    <option value="delete_document_requests">Borrar solicitudes de documentos</option>
                                                    <option value="delete_document_request">Borrar solicitud de documento</option>
                                                    <option value="none">{lang.get('messages.ninguno')}</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="row form-group">
                                            <div class="col-sm-3 text-right col-form-label">
                                            {lang.get('messages.acciones_sobre_documentos')}
                                            </div>
                                            <div class="col-sm-9">
                                                <select class="form-control select2" id="documents_actions_internal" name="documents_actions_internal[]" multiple="multiple">
                                                    <option value="all"  selected="selected">{lang.get('messages.todos')}</option>
                                                    <option value="load">{lang.get('messages.cargar')}</option>
                                                    <option value="comment">{lang.get('messages.comentar')}</option>
                                                    <option value="download">{lang.get('messages.descargar_documento_compartido')}</option>
                                                    <option value="massive_download">{lang.get('messages.descarga_masiva')}</option>
                                                    <option value="individual_download">{lang.get('messages.descarga_individual__previsualizar')}</option>
                                                    <option value="edit">{lang.get('messages.aprobar__rechazar')}</option>
                                                    <option value="export_compact_report">Exportar Reporte Compacto</option>
                                                    <option value="export_extra_fields_report_columns">Exportar Reporte Campos Extra con Columnas</option>
                                                    <option value="none">{lang.get('messages.ninguno')}</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="row form-group">
                                            <div class="col-sm-3 text-right col-form-label">
                                            {lang.get('messages.listado_de_reportes')}
                                            </div>
                                            <div class="col-sm-9">
                                                <select class="form-control select2" id="reports_list_internal" name="reports_list_internal[]" multiple="multiple">
                                                    <option value="all"  selected="selected">{lang.get('messages.todos')}</option>
                                                    <option value="dossiers"  className="disable_report_list">{lang.get('messages.reporte_de_expedientes')}</option>
                                                    <option value="documents" className="disable_report_list">{lang.get('messages.reporte_de_documentos')}</option>
                                                    <option value="none">{lang.get('messages.ninguno')}</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="row form-group">
                                            <div class="col-sm-3 text-right col-form-label">
                                                <span class="card-label font-weight-bold font-size-h4 text-dark-50">Expedientes Propios</span>
                                            </div>
                                        </div>
                                        <div class="row form-group">
                                            <div class="col-sm-3 text-right col-form-label">
                                            {lang.get('messages.acciones_sobre_documentos')}
                                            </div>
                                            <div class="col-sm-9">
                                                <select class="form-control select2" id="documents_actions_own" name="documents_actions_own[]" multiple="multiple">
                                                    <option value="all"  selected="selected">{lang.get('messages.todos')}</option>
                                                    <option value="load">{lang.get('messages.cargar')}</option>
                                                    <option value="comment">{lang.get('messages.comentar')}</option>
                                                    <option value="download">{lang.get('messages.descargar_documento_compartido')}</option>
                                                    <option value="massive_download">{lang.get('messages.descarga_masiva')}</option>
                                                    <option value="individual_download">{lang.get('messages.descarga_individual__previsualizar')}</option>
                                                    <option value="edit">{lang.get('messages.aprobar__rechazar')}</option>
                                                    <option value="export_compact_report">Exportar Reporte Compacto</option>
                                                    <option value="export_extra_fields_report_columns">Exportar Reporte Campos Extra con Columnas</option>
                                                    <option value="none">{lang.get('messages.ninguno')}</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="row form-group">
                                            <div class="col-sm-3 text-right col-form-label">
                                            {lang.get('messages.listado_de_reportes')}
                                            </div>
                                            <div class="col-sm-9">
                                                <select class="form-control select2" id="reports_list_own" name="reports_list_own[]" multiple="multiple">
                                                    <option value="all"  selected="selected">{lang.get('messages.todos')}</option>
                                                    <option value="dossiers"  className="disable_report_list">{lang.get('messages.reporte_de_expedientes')}</option>
                                                    <option value="documents" className="disable_report_list">{lang.get('messages.reporte_de_documentos')}</option>
                                                    <option value="none">{lang.get('messages.ninguno')}</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="row form-group">
                                            <div class="col-sm-3 text-right col-form-label">
                                                {lang.get('messages.acciones_sobre_expedientes')}
                                            </div>
                                            <div class="col-sm-9">
                                                <select id="dossiers_actions_own" class="form-control select2" name="dossiers_actions_own[]" multiple="multiple">
                                                    <option value="all">{lang.get('messages.todos')}</option>
                                                    <option value="download">{lang.get('messages.descargar_expediente_completo')}</option>
                                                    <option value="share">{lang.get('messages.compartir_documentos')}</option>
                                                    <option value="stop_recurrence">Suspender recurrencia</option>
                                                    <option value="start_recurrence">Reactivar recurrencia</option>
                                                    <option value="generate_historic">Generar Documentos historicos</option>
                                                    <option value="replace_template">Reemplazar plantilla de documento</option>
                                                    <option value="delete">Borrar expediente</option>
                                                    <option value="delete_documents">Borrar documentos</option>
                                                    <option value="delete_document_requests">Borrar solicitudes de documentos</option>
                                                    <option value="delete_document_request">Borrar solicitud de documento</option>
                                                    <option value="none">{lang.get('messages.ninguno')}</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    <input type="hidden" value='["all"]' name="user_notifications"/>
                                    {/*
                                    <div class="tab-pane fade" id="kt_tab_pane_3" role="tabpanel" aria-labelledby="kt_tab_pane_2">
                                        <div class="row form-group">
                                            <div class="col-sm-3 text-right col-form-label">
                                                Notificaciones
                                            </div>
                                            <div class="col-sm-9">
                                                <select id="user_notifications" class="form-control select2" name="user_notifications[]" multiple="multiple">
                                                    <option value="all"  selected="selected">Todos</option>
                                                    <option value="user_notifications">Enviar notificaciones a usuarios</option>
                                                    <option value="none">Ninguno</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    */}
                                </div>
                            </div>
                        </div>
                        <div class="row justify-content-end mt-6">
                            <div class="col-sm-8 text-right">
                                <a href="/profiles" class="btn btn-lg btn-secondary">
                                {lang.get('messages.cancelar')}
                                </a>
                                <button id="btnPublish" type="button" class="btn btn-lg btn-primary ml-4">
                                {lang.get('messages.guardar')}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </>
        );
    }
}

export default UserProfileForm;

if (document.getElementById('UserProfileForm')) {
    ReactDOM.render(<UserProfileForm />, document.getElementById('UserProfileForm'));
}
